import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { intToFloatCurrency } from '../../../component/Utils';

function createData(
    acrissCode: string,
    monthlyFee: number
  ) {
    return { acrissCode, monthlyFee:intToFloatCurrency(monthlyFee.toString()) };
  }

interface AcrisMonthlyFeeTableProps{
    data:Record<string,number>,
    t:(columnName:string) => string
}


export default function AcrissMonthlyFeeTable({data,t}:AcrisMonthlyFeeTableProps) {
    const rows = Object.keys(data).map(key => createData(key, data[key]));

    console.log({rows})
    
  return (
    <TableContainer component={Paper} >
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>{t('form.acriss')}</TableCell>
            <TableCell >{t('form.monthlyFee')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row,i) => (
            <TableRow
              key={i}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
               <TableCell component="th" scope="row">
                {row.acrissCode}
              </TableCell>
              <TableCell >{row.monthlyFee}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}